import { render, staticRenderFns } from "./ViewAllNews.html?vue&type=template&id=0453ad83&scoped=true&external"
import script from "./ViewAllNews.vue?vue&type=script&lang=js"
export * from "./ViewAllNews.vue?vue&type=script&lang=js"
import style0 from "./ViewAllNews.scss?vue&type=style&index=0&id=0453ad83&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0453ad83",
  null
  
)

export default component.exports